// extracted by css-extract-rspack-plugin
export default {"button":"_a7e56afe","buttonSpacingTop":"_59aa1854"};